// extracted by mini-css-extract-plugin
export default {"modal":"VideoModal_modal__C6esN","modalContent":"VideoModal_modalContent__aTiAI","close":"VideoModal_close__R-izW","video":"VideoModal_video__nbvjW"};